const options = [
    { image: "/COPO.jpg", label: "COPO MIS", selected: false },
    { image: "/Goaml.jpg", label: "CIB", selected: false },
    { image: "/Goaml.jpg", label: "GO-AML", selected: false },
    { image: "/NEFSCUN.jpg", label: "NEFSCUN", selected: false },
    { image: "/DistrictCoop.jpg", label: "District COOP Reporting", selected: false },
    {
        image: "/DistrictCoop.jpg",
        label: "Municipality Cooperative Department",
        selected: false,
    },
    { image: "/DistrictCoop.jpg", label: "Provincial Cooperative Department", selected: false },
];

export default options;